module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><path d=\"M176 560c-4.095 0-8.189-1.562-11.314-4.687l-160-160c-6.248-6.248-6.248-16.379 0-22.627s16.379-6.248 22.628 0l148.686 148.686 436.687-436.686c6.248-6.248 16.379-6.248 22.627 0s6.249 16.379 0 22.628l-448 448c-3.125 3.124-7.219 4.686-11.314 4.686z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./frontend/images/icons/tick.svg
// module id = 742
// module chunks = 0